import {
  INTERSTITIAL_COOKIE,
  SHOW_CLASS,
  UA_ANDROID_CLASS,
  UA_IOS_CLASS,
} from "@/app/constants/interstitial";
import { PHONE_UA } from "@/app/utils/resolveMobileBrowser";

// Serialize a regex (source + flags) so the boot string reconstructs it exactly.
const re = (r: RegExp) =>
  `new RegExp(${JSON.stringify(r.source)},${JSON.stringify(r.flags)})`;

/**
 * A self-contained script that runs during HTML parse, before the landing
 * paints, so a phone visitor never sees the marketing page flash before the
 * overlay. It REVEALS the pre-rendered-but-hidden interstitial for a phone
 * browser (adds `SHOW_CLASS` to <html>) and marks the platform (`UA_IOS_CLASS` /
 * `UA_ANDROID_CLASS`) so CSS shows the matching, already server-rendered download
 * link. Both links are static and React-owned, so the CTA is tappable from first
 * paint with zero JS beyond this class toggle. Scroll is locked on <body> to match
 * the app's other modals (iOS Safari does not lock reliably on <html> alone).
 * Built from the shared PHONE_UA sources WITH their flags so it stays in lockstep
 * with `phoneBrowserPlatform`. Wrapped in try/catch: it must never break the landing.
 *
 * SECURITY: every interpolation below is a compile-time constant. This string is
 * injected via `dangerouslySetInnerHTML` on a page cached publicly for ~12840s, so
 * a request-derived value here would become stored XSS served from the edge. Never
 * interpolate anything that is not a program constant.
 */
export function interstitialBootScript(): string {
  return `(function(){try{
var ua=navigator.userAgent||"";
if(${re(PHONE_UA.bot)}.test(ua))return;
if(${re(PHONE_UA.native)}.test(ua))return;
if(${re(PHONE_UA.ipad)}.test(ua))return;
var ios=${re(PHONE_UA.iphone)}.test(ua);
var android=${re(PHONE_UA.android)}.test(ua)&&${re(PHONE_UA.mobile)}.test(ua);
if(!ios&&!android)return;
if(new RegExp("(?:^|; )"+${JSON.stringify(INTERSTITIAL_COOKIE)}+"=1(?:;|$)").test(document.cookie))return;
document.documentElement.classList.add(${JSON.stringify(SHOW_CLASS)},ios?${JSON.stringify(UA_IOS_CLASS)}:${JSON.stringify(UA_ANDROID_CLASS)});
if(document.body)document.body.style.overflow="hidden";
}catch(e){}})();`;
}
